import axios from 'axios';

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;


export function getSkinCareData() {
  // your long populate string

   return axios.get( `${CMS_BASE_URL}skincare-news?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
 
}

// Single-request alternative to paginating get_report_list — checks on exactly
// one normal skin care submission by its request_id (ORDERID/REPORTID in the
// get_report_list row shape).
// STATUS: 0 queued, 3 backend accepted/polling, 1 done, 2 failed.
export function getSkincareStatus(requestId, patientid) {
  const url = new URL(`skincare-status/${requestId}`, process.env.REACT_APP_QUANTUMURL).toString();
  return axios.get(url, { params: { patientid } });
}

export function postSkincareImageReport(payload) {

  return axios.post(
    `${process.env.REACT_APP_SKINCARE}predict`,

    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    }
  );
}



